import { render, staticRenderFns } from "./officialMsg_node_form.vue?vue&type=template&id=1fa1a3e9&"
import script from "./officialMsg_node_form.vue?vue&type=script&lang=js&"
export * from "./officialMsg_node_form.vue?vue&type=script&lang=js&"
import style0 from "./officialMsg_node_form.vue?vue&type=style&index=0&id=1fa1a3e9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports